<div class="container customer-account">
  <div class="row pos-relative">   
    <div class="col-md-3 col-lg-2 left-nav">
      <div class="persistant-info pos-relative">

        <!-- Place a refresh button on left section CCR6-1978  -->
        <button mat-button color="primary" title="Refresh" class="refresh-button hide1" (click)="refreshCustAccount()">
          <f-icon class="blue" icon-config='{"iconName": "arrows-rotate", "iconType": "solid", "iconSize": "s"}'></f-icon>
        </button>

        
        <app-loader *ngIf="cusAccService.firstLoadLoader" [loaderType]="loaderType"
          [loaderMsg]="cusAccService.showLoaderMsg"></app-loader>

        <span>
          <p class="client-name">
            {{ getClientName() }}            
          </p>
          <!-- CCR1-14992 Persistent Info changes -->
          <p class="sector" *ngFor="let field of rootScope.activeCustTab?.clientSpecificDynamicFields || []"><strong>{{ field.elementLabel }}:</strong> {{ field.elementValue }} </p>
          <div class="client-cust-name">
            {{ rootScope.activeCustTab?.title | titlecase }}
            <!--Person Internal Ids-->
            <span class="internal-id-icon">
              <f-button
                class="internal-id"
                text=""
                isIconOnly = "true"
                title="Click on this card to view all person internal IDs"
                variant="ghost"
                icon-config='{"iconName": "id-card", "iconType": "light", "iconPlacement": "right"}'
                (buttonClicked)="openPersonInternalId()">
            </f-button>
            </span>
            <p class="vip-indicator" *ngIf="rootScope.activeCustTab?.isVIP ===true"><span>VIP</span></p>
          </div>
          <div class="preferred-name" *ngIf="rootScope.activeCustTab?.preferredName">
            <span> "{{ rootScope.activeCustTab?.preferredName }}" </span>
          </div>
          <!-- CCR6-1735 --> 
          <div class="lang-info" *ngIf="getPrimaryLanguageOrPreferredLocale() !== '' || getPronouns() !== ''">
            <p class="lang-details research" *ngIf="getPrimaryLanguageOrPreferredLocale() !== ''"> <span class="lang-value">{{ getPrimaryLanguageOrPreferredLocale()
                }}</span>
            </p>
            <p class="pronoun-indicator research"*ngIf="getPronouns() !== ''">
              {{ getPronouns()
                }}
            </p>
          </div>

          <!-- CCR1-14992 Persistent Info changes -->
        <div class="official-details">
          <ng-container *ngFor="let item of rootScope.activeCustTab?.persistentInfo || [];">
            <p *ngIf="!isSectorField(item)">
              <span class="field-label">
                {{ item.elementLabel }}: 
              </span>
        
              <span class="details-value"> 
                {{ getPersistentFieldValue(item) }}
        
                <f-tooltip *ngIf="item.title?.trim()" [content]="getTooltipContent(item)" position="left" variant="icon"
                  trigger-event-type="hover" [iconConfig]="iconConfig3">
                </f-tooltip>
              </span>
            </p>
          </ng-container>
        </div>
        
          <!-- time-duration section Only enable in case active of active chat or active call -->
          <div class="time-duration " *ngIf="enableTimerRowForChat()">
            <span class="clock-icon">
              <f-icon icon-config='{"iconName": "clock", "iconType": "light", "iconSize": "s"}'></f-icon></span>
            <span class="time">{{ timerVal }}</span>
            <span class="duration">Started {{getStartTime() }}</span>
          </div>

          <!-- time-duration section Only enable in case active of active call -->
          <div class="time-duration " *ngIf="enableTimerRow()">
            <span class="clock-icon"><f-icon icon-config='{"iconName": "clock", "iconType": "light", "iconSize": "s"}'></f-icon></span>
            <span class="time">{{getTimerVal()}}</span>
            <span class="duration">Started {{getStartTime() }}</span>
          </div>

          <!--CCR6-1735 Below class has to be hidden for Research mode. -->
          <div class="account-info" *ngIf="rootScope.activeCustTab.CS_SECURITY_LEVEL !== '0' &&
           this.rootScope.activeCustTab.additionalAccount!==true">
            <p class="auth-status  {{
              cusAccService.identifyAuthenticateClass(
                rootScope.activeCustTab.authenticateStatus
              )
            }}">
              <span> {{ rootScope.activeCustTab.authenticateStatus }} </span>
            </p>
            
            <!-- account freeze status  CCR1-8130 -->
            <p class="auth-status freeze " *ngIf="accountFreezeStatus()">
            
              <span> Account Frozen </span>
            </p>

          </div>
          <!-- CCr6-1735 Below class has to be hidden for Research mode. -->
          <div class="account-info" *ngIf="rootScope.activeCustTab.CS_SECURITY_LEVEL !== '0' &&
          this.rootScope.activeCustTab.additionalAccount!==true">
            <p class="customer-info-type"><span>{{ getCustomerType(rootScope.activeCustTab.customerType) }}</span></p>
            <p class="role-type"> <span>{{ getAbbrevatedRoleValue(rootScope.activeCustTab.defaultRole)}} </span></p>
          </div>


          <!-- when customer have more than one TBA account then this dropdown
             would be appear otherwise it should not be visiable -->
          <app-alight-drop-down class="tba-dropdown hide" [group]="customerAccForm" value="fieldValue"
            description="fieldValueDescription" label="TBA Account Type" [list]="Tbavalues"></app-alight-drop-down>

        </span>
      </div>
      <span *ngIf="showDivider()" class="section-divider"></span>

      <div class="customer-left-nav pos-relative">        
       
        <app-loader *ngIf="cusAccService.firstLoadLoader || cusAccService.leftNavLoader" [loaderType]="loaderType"
          [loaderMsg]="cusAccService.showLoaderMsg"></app-loader>

        <!-- This error msg will only show in case of customer-left-nav api get faild  -->
        <section
          *ngIf="
            cusAccService?.activeTabDt?.navBarErrMsg &&
            cusAccService?.activeTabDt?.navBarErrMsg !== 'NA' &&  cusAccService?.activeTabDt?.navBarErrMsg !== noDataMsg 
            && !(cusAccService?.activeTabDt?.clientInfoErrMSg !== 'NA' &&  cusAccService?.activeTabDt?.clientInfoErrMSg !== noDataMsg)"
          class="error-wrapper">
          <f-alert variant="{{
              cusAccService?.activeTabDt?.navBarErrMsg === noDataMsg
                ? 'warning'
                : 'error'
            }}">
            <p>
              {{ cusAccService?.activeTabDt?.navBarErrMsg }}
            </p>
          </f-alert>
          <button mat-button color="primary" title="Refresh" class="btn-refresh hide">
            Refresh            
            <f-icon icon-config='{"iconName": "arrows-rotate", "iconType": "solid", "iconSize": "s"}'></f-icon>
          </button>
        </section>
        <div *ngFor="
            let menu of cusAccService.activeTabDt?.navBar?.menuList;
            let last = last
          ">
          <button class="no-child-tab" *ngIf="menu.subMenuList.length === 0" [ngClass]="{
              active: tempMenuId
                ? tempMenuId === menu.id
                : selectedMenu === menu.id
            }">
           <span *ngIf="menu?.icon !== null && menu?.icon !== ''" >
            <f-icon [iconConfig]="{iconName: menu.icon, iconType: 'light', iconSize: 's'}"></f-icon>
            </span>

            <span (click)="activateLeftMenu(menu.id, 0, menu)" [ngClass]="menu.style">{{ menu.heading }}</span>
          </button>
          <div class="customer-info-tab" *ngIf="menu.subMenuList.length > 0">
            <mat-accordion>
              <mat-expansion-panel [expanded]="menu.id === sideNavState" disabled={{!menu.linkEnable}}>
                <mat-expansion-panel-header [ngClass]="{'linkDisabled': !menu.linkEnable}">
                  <mat-panel-title>  
                    <span *ngIf="menu?.icon !== null && menu?.icon !== ''" >
                      <f-icon [iconConfig]="{iconName: menu.icon, iconType: 'light', iconSize: 's'}"></f-icon>
                    </span>
                    <span [ngClass]="menu.style">{{ menu.heading }}</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ul>
                  <li *ngFor="
                      let subMenu of menu.subMenuList | sortBy: 'heading';
                      let i = index
                    " id="{{ subMenu.id }}" [ngClass]="{'linkDisabled': !enableLink(subMenu)}">
                    <button [disabled]="!enableLink(subMenu)" class="no-child-tab" title={{subMenu.heading}}
                      *ngIf="subMenu.subMenuList?.length === 0" (click)="activateLeftMenu(subMenu.id, 0, subMenu)"
                      [ngClass]="{
                        active: tempMenuId
                          ? tempMenuId === subMenu.id
                          : selectedMenu === subMenu.id
                      }" [attr.tabIndex]="!subMenu?.linkEnable?-1:''">  
                      <span *ngIf="subMenu?.icon !== null && subMenu?.icon !== ''" >                
                         <f-icon [iconConfig]="{iconName: subMenu.icon, iconType: 'light', iconSize: 's'}"></f-icon>
                    </span>
                      <span [ngClass]="subMenu.style">{{
                        subMenu.heading
                        }}</span>
                    </button>
                    <ng-container *ngIf="subMenu.subMenuList?.length > 0">
                      <mat-accordion class="nestedAccrodion">
                        <mat-expansion-panel [expanded]="subMenu.id === subMenuId" disabled="{{!subMenu?.linkEnable}}">
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <span *ngIf="subMenu?.icon !== null && subMenu?.icon !== ''" >   
                              <f-icon [iconConfig]="{iconName: subMenu.icon, iconType: 'light', iconSize: 's'}"></f-icon>
                              </span>

                              <span [ngClass]="subMenu.style" [ngClass]="{'linkDisabled':!subMenu?.linkEnable}"
                                [attr.tabIndex]="!subMenu?.linkEnable?-1:''">{{
                                subMenu.heading
                                }}</span>
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <ul class="subLinks">
                            <li *ngFor="
                                let nestedMenu of subMenu.subMenuList
                                  | sortBy: 'heading';
                                let i = index
                              " id="{{ nestedMenu.id }}" (click)="
                                activateLeftMenu(nestedMenu.id, i, nestedMenu)
                              " [ngClass]="{
                                'tab-active': tempMenuId
                                  ? tempMenuId === nestedMenu.id
                                  : selectedMenu === nestedMenu.id
                              }" [ngClass]="{'linkDisabled': cusAccService.disableDomainLink(nestedMenu)}"
                              [attr.tabIndex]="!nestedMenu?.linkEnable?-1:''">
                              <button [ngClass]="nestedMenu.style" [attr.tabIndex]="!nestedMenu?.linkEnable?-1:''"
                                [ngClass]="{'linkDisabled':cusAccService.disableDomainLink(nestedMenu)}" title={{nestedMenu.heading}}
                                [disabled]=' cusAccService.disableDomainLink(nestedMenu)'>{{
                                nestedMenu.heading }}</button>
                            </li>
                          </ul>
                        </mat-expansion-panel>
                      </mat-accordion>
                    </ng-container>
                  </li>                  
                </ul>

               
              </mat-expansion-panel>
            </mat-accordion>
            <div class="section-divider" *ngIf="!last"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-9 col-lg-10 pos-relative customer-right-panel">
      <app-filter-data class="interaction-overlay" *ngIf="rootScope.openInteractionFilter"></app-filter-data>
      <app-create-alert class="alert-overlay" *ngIf="rootScope.openCreateAlertDialog && (selectedMenu === navbarMenu.custOverview ||  selectedMenu === navbarMenu.wrap_up || selectedMenu === navbarMenu.approvedException)">
      </app-create-alert>
      <app-custom-dialog *ngIf="rootScope.customDialogData.displayCustomDialogCA" (actionOnClick)="buttonClick($event)">
      </app-custom-dialog>
      <app-view-expired-alerts class="alert-overlay" *ngIf="rootScope.activeCustTab.viewExpiredAlert && (selectedMenu === navbarMenu.custOverview ||  selectedMenu === navbarMenu.wrap_up || selectedMenu === navbarMenu.approvedException)"></app-view-expired-alerts>


      <app-customer-account-dialog id="idleAlert" *ngIf="openIdlePop()">
        <div id="content">
          <p>
            This customer’s account has been idle for a while. If no further
            action is needed, close it.
          </p>
          <div class="custom-overlay-footer">
            <f-button [appAutoFocus]="true" text="Got it" title="Got it" mat-dialog-close tabindex="1" type="button"
              variant="progressive" (buttonClicked)="customerService.idleTimeReset()"></f-button>
          </div>
        </div>
      </app-customer-account-dialog>

      <!-- Expired alert popup here -->
      <app-customer-account-dialog id="expiredAlert" class="hide1" *ngIf="showExpiredAlert">
        <div id="content">
          <div class="auth-header">
            <h6 class="custom-model-heading">Expired Attention Items</h6>
            <div class="close-btn">
              <button mat-icon-button mat-dialog-close (click)="closeAlertpopup()">                
                <f-icon iconConfig="{iconName: 'xmark', iconType: 'light', iconSize: 's'}"></f-icon>
              </button>
            </div>
          </div>
          <!--  error wrapper added as to show edits.
          Please confirm the error copy with the PO -->

          <section class="error-wrapper hide">
            <f-alert variant="error">
              <p> There was a problem loading the data for this card. </p>
            </f-alert>
          </section>

          <h4>Date Range</h4>
          <div class="date-filter">
            <div class="date-range-fields">
              <mat-form-field appearance="fill" class="component-box">
                <mat-label>Date from (MM/DD/YYYY) </mat-label>
                <input matInput [matDatepicker]="picker" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>

              <mat-form-field appearance="fill" class="component-box">
                <mat-label>Date to (MM/DD/YYYY) </mat-label>
                <input matInput [matDatepicker]="picker2" />
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>

              <f-button text="Search" title="Search" type="button" variant="progressive"></f-button>
            </div>

            <div class="error-wrapper hide">
              <p>
                <f-icon [iconConfig]="{iconName: 'circle-exclamation', iconType: 'solid', iconSize: 's'}"></f-icon> Error - Incorrect date range selected.</p>
            </div>
          </div>
          <div class="result-data form-scroll">

            <div class="result-data-left">

              <table mat-table [dataSource]="dataSource" class="alert-table" aria-label="Customer Account Table ">

                <ng-container matColumnDef="title">
                  <th mat-header-cell *matHeaderCellDef> Title </th>
                  <td mat-cell *matCellDef="let element"> {{element.title}} </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="author">
                  <th mat-header-cell *matHeaderCellDef> Author </th>
                  <td mat-cell *matCellDef="let element"> {{element.author}} </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="expiration">
                  <th mat-header-cell *matHeaderCellDef> Expiration </th>
                  <td mat-cell *matCellDef="let element"> {{element.expiration}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
            <div class="result-data-right">
              <f-data-card class="ih-card-container">
                <div class="flex justify-space-between">
                  <h6 class="heading">
                    Details
                  </h6>
                </div>
                <div class="container form">
                  <div class="row">
                    <div class="col-md-4">
                      <span class="form-label"> Type </span>
                      <span class="form-value"> Lorem ipsum </span>
                    </div>
                    <div class="col-md-4">
                      <span class="form-label">Subtype </span>
                      <span class="form-value"> Lorem ipsum </span>
                    </div>
                    <div class="col-md-4">
                      <span class="form-label"> Author</span>
                      <span class="form-value"> Michaelangelo A </span>
                    </div>
                  </div>


                  <div class="section-divider"></div>
                  <div class="row">
                    <div class="col-md-4">
                      <span class="form-label"> Created </span>
                      <span class="form-value"> Jan-01-2023 </span>
                    </div>
                    <div class="col-md-4">
                      <span class="form-label"> Expiration </span>
                      <span class="form-value"> Jan-31-2023 </span>
                    </div>
                    <div class="col-md-4">
                      <span class="form-label"> Deadline </span>
                      <span class="form-value"> Jan-31-2023 </span>
                    </div>
                  </div>
                  <div class="section-divider"></div>
                  <div class="row">
                    <div class="col-md-12">
                      <span class="form-label"> Title </span>
                      <span class="form-value"> Bad mobile phone - number on fil </span>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-12 ">
                      <span class="form-label"> Details </span>
                      <span class="form-value alert-details"> Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Donec suscipit erat quis gravida tincidunt. In pellentesque, lorem eu molestie aliquet, ex diam
                        placerat tortor, a venenatis neque quam in velit. Integer quis ultrices nisl, vitae blandit sem.
                      </span>
                    </div>
                  </div>
                </div>
              </f-data-card>
            </div>
          </div>
        </div>
      </app-customer-account-dialog>

      
      <!------------Right side block --------------------------------------------------------------->

  <section *ngIf="rootScope.activeCustTab.displayErrorDomainMsg" class="error-wrapper" >
      
        <f-alert variant="warning" > 
        <p> The {{ rootScope.activeCustTab.errorDomains}} API failed to load.  Please partner with your leader to open a CCTS Jira for Support to investigate. </p> 

        </f-alert>
     </section>



      <!-- For  authentication Tab -->
      <app-authentication (goToApprovedExceptionPageEmitter)="goToApprovedExceptionPage($event)"
        (changeCustomerTypeEmitter)="onCustomerTypeChange($event)" *ngIf="selectedMenu === navbarMenu.authentication"
        (goToCustomerOverviewPageEmitter)="goToCustomerOveriew($event)">
      </app-authentication>

      <!-- For  approved exception Tab -->
      <app-approved-exception (changeCustomerTypeEmitter)="onCustomerTypeChange($event)"
        (goToCustomerOveriew)="goToCustomerOveriew($event)" *ngIf="selectedMenu === navbarMenu.approvedException">
      </app-approved-exception>

      <!-- For  wrap-up Tab -->
      <app-wrap-up *ngIf="selectedMenu === navbarMenu.wrap_up" [id]="rootScope.activeCustTab.customerSessionId">
      </app-wrap-up>

        <!-- For Privacy Policy Tab -->
      <app-privacy-policy *ngIf="selectedMenu === navbarMenu.privacyPolicy"
        (goToCustomerOverviewEmitter)="goToCustomerOveriew($event)">
      </app-privacy-policy>

      <div class="row" *ngIf="!isIHListView">
        <!-- For  Authentication Status card -->
        <div class="col-md-12 col-lg-6 about-customer" *ngIf="selectedMenu === navbarMenu.custOverview">
          <app-abt-the-interaction-card (changeCustomerTypeEmitter)="onCustomerTypeChange($event)"
            (goToAuthenticatePageEmitter)="goToAuthenticatePage($event)"
            [defaultRole]="rootScope.activeCustTab.defaultRole"></app-abt-the-interaction-card>
          <!-- About the interaction end -->
     
          <!-- Interaction History with 5 records with content-->
          <div class="interaction-history" *ngIf="selectedMenu === navbarMenu.custOverview">
            <app-interaction-history-brief-view (viewAllIHList)="goToListViewIHPage($event)"
              [id]="rootScope.activeCustTab.customerSessionId"></app-interaction-history-brief-view>
          </div>

        </div>

        <div class="
            col-md-12 col-lg-6
            offset-lg-0
            *ngIf='selectedMenu===navbarMenu.custOverview'
          ">
          <app-loader *ngIf="cusAccService.clientInfoLoader" [loaderType]="loaderType" [loaderMsg]="cusAccService.clientInfoLoader" ></app-loader>
          <div class="row">
            <!-- client Info carousel -->
            <div class="col-md-12 manual-alert" *ngIf="selectedMenu === navbarMenu.custOverview">
              <f-data-card class="pos-relative">
                <div class="card-header">
                  <h5>Client Info</h5>
              
              
                  <button mat-button1 color="primary" class="show-hide" id="toggle-1"
                  (click)="showContent1 = !showContent1">                    
                    <span *ngIf="!showContent1">
                      <f-icon [iconConfig]="{iconName: 'angle-down', iconType: 'light', iconSize: 's'}"></f-icon>
                    </span>
                    <span *ngIf="showContent1">
                      <f-icon [iconConfig]="{iconName: 'angle-up', iconType: 'light', iconSize: 's'}"></f-icon>
                    </span>
                  </button>
                </div>

                <div class="show-hide-data"  *ngIf="showContent1">

                <section class="error-wrapper" *ngIf="cusAccService.checkDefaultPinLoadApiFail()">
                  <f-alert variant="error">
                    <p> There was a problem loading the data. <button class="btn-alert"
                        (click)="cusAccService.getDefaultPin()">Try again</button> </p>
                  </f-alert>
                </section>
                <section class="error-wrapper" *ngIf="cusAccService.checkCreateUpdateDefaultPinApiFail()">
                  <f-alert variant="error">
                    Unable to update default pin please try again on clicking of hollow pin icon
                  </f-alert>
                </section>

                <section class="no-result"
                  *ngIf="rootScope.displayNoDataMsgOnClientInfoCard(rootScope.activeCustTab.clientId)">
                  <p> No data available </p>
                </section>

                <app-carousel *ngIf="!rootScope.displayNoDataMsgOnClientInfoCard(rootScope.activeCustTab.clientId)"
                  [cardComponents]="rootScope.clientInfoCard.clientInfoVSClientIdMap[rootScope.activeCustTab.clientId]">
                </app-carousel>

              </div>

              </f-data-card>
            </div>

            <!-- Manual alert -->
          
            <div class="col-md-12 manual-alert hide1" *ngIf="selectedMenu === navbarMenu.custOverview && rootScope.activeCustTab.loadDisplayAlertComp">
              <f-data-card class="pos-relative">
                <app-display-alert [id]="rootScope.activeCustTab.customerSessionId" [isLiveCall]="rootScope.isLiveCall"
                  [newAlert]="this.rootScope.isAlertAdded" [newAlertId]="rootScope.newAlertId" 
                  [refreshAlertList]="rootScope.refreshAlertList"></app-display-alert>
              </f-data-card>

            </div>
            <!-- Case Management Card  -->
            <div class="col-md-12 customer-tickets" *ngIf="selectedMenu === navbarMenu.custOverview">
              <app-customer-case-management-card></app-customer-case-management-card>
              <app-loader *ngIf="cusAccService.firstLoadLoader" [loaderType]="loaderType"
                [loaderMsg]="cusAccService.showLoaderMsg"></app-loader>
            </div>

          </div>
        </div>
      </div>
      <!--common-detail section -->
      <!-- **** please remove hide class to enable the about customer section on page **** -->
      <div class="row" *ngIf="
          selectedMenu !== navbarMenu.custOverview &&
          (cusAccService.domainData || cusAccService.domainErrMsg)
        ">
        <div class="col-md-12 customer-detail-container"
          *ngIf="!isIHListView && (selectedMenu !== navbarMenu.wrap_up) && (selectedMenu !== navbarMenu.approvedException)
          && (selectedMenu !==  navbarMenu.authentication) && (selectedMenu !==  navbarMenu.onDemandEmail) && (selectedMenu !==  navbarMenu.viewJson)  && (selectedMenu !==  navbarMenu.privacyPolicy)">
          <app-domain-details [selectedIndex]="cusAccService.selectedIndex" [domainData]="cusAccService.domainData"
            [domainErrMsg]="cusAccService.domainErrMsg" [domainName]="domainName"></app-domain-details>
        </div>
      </div>
      <!--Interaction History Page -->
      <app-interaction-history-list-view *ngIf="selectedMenu === navbarMenu.interactionHistoty && isIHListView"
        [selectedRow]="selectedRow" [id]="rootScope.activeCustTab.customerSessionId">
      </app-interaction-history-list-view>      

      <!-- For On demand Email Tab --> 
      <app-on-demand-email  *ngIf="selectedMenu === navbarMenu.onDemandEmail" ></app-on-demand-email>

      <!--For View JSON Feature /ccr1-10390-->
       <app-view-json  *ngIf="selectedMenu === navbarMenu.viewJson" ></app-view-json>

  </div>
 <!-- Outbound popup here -->
 <app-customer-account-dialog class="hide1 outbound-call-overlay" *ngIf="rootScope.activeCustTab.outboundCallInitiate">
  <div id="content">
    <div class="alert-header">
      <h6 class="custom-model-heading">Making outbound call</h6>
      <!-- Close  button should be enabled on conditional basis -->
      <div class="close-btn hide">
        <button mat-icon-button mat-dialog-close (click)="closeAlertpopup()">
          <f-icon [iconConfig]="{iconName: 'xmark', iconType: 'light', iconSize: 'm'}"></f-icon>
        </button>
      </div>
    </div>
    <p>You need to make the call in ALIS by selecting "Start a Conversation". Once the call is established, this popup will automatically close.</p>
    <p class="margin-top-gap">Select “Cancel” only if you no longer wish to make the outbound call.</p>
    <div class="custom-overlay-footer">
      <f-button text="Cancel" mat-dialog-close tabindex="1" title="Cancel" type="button" variant="action"
        (click)="cancelTriggerOutboundCall()">
      </f-button>
    </div>
  </div>
</app-customer-account-dialog>
    <!-- CCR6-1696 -->

    <app-customer-account-dialog id="TXTcallerType" *ngIf='rootScope.callerTypeAlert&&rootScope.isLiveCall'>
      <div id="content">
        <div class="alert-header">
          <h6 class="custom-model-heading">Authentication Status Change</h6>
        </div>
        <p class="subheading">
          Changing Caller Type will cause this customer account to become Unsecured.
        </p>

        <div class="custom-overlay-footer">
          <f-button text="Cancel" mat-dialog-close tabindex="1" title="Cancel" type="button" variant="action"
            (buttonClicked)="closeCTPopUp()" (keydown.enter)="closeCTPopUp()">
          </f-button>
          <f-button text="Change" mat-dialog-close tabindex="2" title="Change" type="button" variant="progressive"
            (buttonClicked)="closeCTPopUp($event)" (keydown.enter)="closeCTPopUp($event)">
          </f-button>
        </div>
      </div>
    </app-customer-account-dialog>
  </div>
 
</div>  
